export const HYDRATION_STANDARD_SCROLL_BUFFER = 750;

export const RECS_REQUEST_KEY = 'aGAQFG4j6QtVTSWqujfFYWeIU6BR5Mee';

export const configuratorURLS = [
  { name: 'Carpet Configurator', url: 'https://custom.homedepot.com/flooring' },
];

export const configuratorBreadcrumbsData = {
  searchModel: {
    searchReport: {
      totalProducts: 1206,
      didYouMean: null,
      correctedKeyword: null,
      keyword: null,
      pageSize: 24,
      searchUrl: '',
      sortBy: 'topsellers',
      sortOrder: 'desc',
      startIndex: 0
    },
    taxonomy: {
      breadCrumbs: [
        {
          browseUrl: '/b/Flooring/N-5yc1vZaq7r',
          creativeIconUrl: null,
          deselectUrl: null,
          dimensionId: null,
          dimensionName: 'Category',
          label: 'Flooring',
          refinementKey: 'aq7r',
          url: '/b/Flooring/N-5yc1vZaq7r'
        },
        {
          browseUrl: '/b/Flooring-Carpet/N-5yc1vZarl0',
          creativeIconUrl: null,
          deselectUrl: null,
          dimensionId: null,
          dimensionName: 'Category',
          label: 'Carpet',
          refinementKey: 'arl0',
          url: '/b/Flooring-Carpet/N-5yc1vZarl0'
        },
        {
          browseUrl: '/b/Flooring-Carpet-Installed-Carpet/N-5yc1vZ2fkpcfz',
          creativeIconUrl: null,
          deselectUrl: null,
          dimensionId: null,
          dimensionName: 'Category',
          label: 'Installed Carpet',
          refinementKey: '2fkpcfz',
          url: '/b/Flooring-Carpet-Installed-Carpet/N-5yc1vZ2fkpcfz'
        }
      ]
    }
  },
};
